import { Manifest } from '../configuration/Manifest';
import { TemplateConfiguration } from '../models/app/TemplateConfiguration';
import { TEMPLATE_CONFIGURATION } from '../configuration/development.templateConfig';

export class TemplateStore {
    templateConfiguration: TemplateConfiguration | undefined;

    async initialize() {
        await this.getTemplateConfiguration();
    }

    get appConfigSource() {
        return (
            (this.templateConfiguration &&
                this.templateConfiguration.appConfigSource) ||
            'files'
        );
    }

    get externalScriptsBasePath() {
        return (
            this.templateConfiguration &&
            this.templateConfiguration.externalScriptsBasePath
        );
    }

    get cacheOptions() {
        return (
            this.templateConfiguration &&
            this.templateConfiguration.cacheOptions
        );
    }

    get assetsBaseUrl(): string {
        return Manifest.getBaseUrl('');
    }

    async getTemplateConfiguration(): Promise<void> {
        const environment = process.env.NODE_ENV;
        if (environment !== 'development') {
            try {
                this.templateConfiguration = require('../configuration/templateConfig.json');
            } catch (ex) {
                console.error(ex);
            }
        } else {
            this.templateConfiguration = TEMPLATE_CONFIGURATION;
        }
    }
}



// WEBPACK FOOTER //
// ./src/stores/TemplateStore.ts